import React, { Component } from 'react';
import PropTypes from 'prop-types';

import TagHider from './TagHider';

class HideTagList extends Component {
  render() {
    const { tags, pendingTags, togglePendingHiddenTag } = this.props;
    return (
      <ol className="RecommendationTagList">
        {tags.map((tag, i) => {
          const pendingTag = pendingTags.find(
            pt => pt.id === tag.id && pt.schema === tag.schema
          );
          return (
            <li className={`TagListItem`} key={i}>
              <TagHider
                isPending={!!pendingTag}
                onClick={togglePendingHiddenTag}
                tag={tag}
              />
            </li>
          );
        })}
      </ol>
    );
  }
}

HideTagList.propTypes = {
  tags: PropTypes.arrayOf(PropTypes.object).isRequired,
  togglePendingHiddenTag: PropTypes.func.isRequired,
};

export default HideTagList;



// WEBPACK FOOTER //
// ./src/Components/Pages/Results/Recommendations/RecommendationHideMenu/HideTagList.js